<template>

      <v-card>
        <v-card-title class="pb-0">
        <v-row>
        <v-col cols="3">
          <span class="headline mr-3">Tasks</span>
          <AddTask2/>
        </v-col>
        <v-col cols="4">
            <v-row>
            <v-col cols="4" class="pa-0">
              <v-checkbox
                v-model="notdone"
                value="1"
                label="Not Done"
                type="checkbox"
                class="mt-0"
                ></v-checkbox>
            </v-col>
            <v-col cols="4" class="pa-0">
              <v-checkbox
                v-model="hold"
                value="1"
                label="Hold"
                type="checkbox"
                class="mt-0"
                ></v-checkbox>
            </v-col>
            <v-col cols="4" class="pa-0">
              <v-checkbox
                v-model="done"
                value="1"
                label="Done"
                type="checkbox"
                class="mt-0"
                ></v-checkbox>
            </v-col>
            </v-row>
        </v-col>
        <v-col cols="5">
            <v-row>
            <v-col cols="2" class="pa-0">
              <v-checkbox
                v-model="low"
                value="1"
                label="Low"
                type="checkbox"
                class="mt-0"
                ></v-checkbox>
            </v-col>
            <v-col cols="3" class="pa-0">
              <v-checkbox
                v-model="medium"
                value="1"
                label="Medium"
                type="checkbox"
                class="mt-0"
                ></v-checkbox>
            </v-col>
            <v-col cols="3" class="pa-0">
              <v-checkbox
                v-model="high"
                value="1"
                label="High"
                type="checkbox"
                class="mt-0"
                ></v-checkbox>
            </v-col>
            </v-row>
        </v-col>
        
        </v-row>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="12">
                <v-simple-table class="w-100">
                    <template v-slot:default>
                        <thead>
                            <tr>
                            <th>Task</th>
                            <th>Assign To</th>
                            <th>Project Name</th>
                            <th>Priority</th>
                            <th>Status</th>
                            <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="task in tasks" :key="task.id">
                                <td>{{ task.task }}</td>
                                <td>{{ task.assignto.name }}</td>
                                <td>{{ task.project.title }}</td>
                                <td><span :class="task.priority == 'Low' ? 'lightblue--text' : (task.priority == 'Medium') ? 'orange--text' : 'red--text'">{{ task.priority }}</span></td>
                                <td>
                                    <v-chip class="ma-1" v-if="task.status == 0" small color="error">pending</v-chip>
                                    <v-chip class="ma-1" v-if="task.status == 1" small color="warning">hold</v-chip>
                                    <v-chip class="ma-1" v-if="task.status == 2" small color="success">done</v-chip>
                                </td>
                                <td><v-btn color="warning" class="mr-2" v-if="task.status == 0" x-small @click.prevent="holdtask(task)">hold</v-btn>
                                    <v-btn color="info" class="mr-2" v-if="task.status == 1" x-small @click.prevent="unholdtask(task)">unhold</v-btn>
                                    <v-btn color="success" class="ml-1" v-if="task.status != 2" x-small @click.prevent="donetask(task)">done</v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                </v-col>
            </v-row>
        </v-card-text>
      </v-card>
       
</template>

<script>

import { mapGetters,mapActions } from 'vuex';
import sendMessage from '../apis/sendMessage.js';
import AddTask2 from './AddTask2.vue';
  export default {
    components: {
      AddTask2
    },
    data: function() {
      return {
          low: 0,
          medium: 0,
          high: 0,
          notdone: 0,
          done: 0,
          hold: 0,
        }
    },
    computed: {
      ...mapGetters(["alltasks","currentuser"]),
      tasks() {
          return this.alltasks.filter(task => task.assign_to === this.currentuser.id)
          .filter(task => {
            if(this.low) { return "Low" === task.priority;}
            return true;
            })
            .filter(task => {
            if(this.medium) { return "Medium" === task.priority;}
            return true;
            })
            .filter(task => {
            if(this.high) { return "High" === task.priority;}
            return true;
            })
            .filter(task => {
            if(this.notdone) { return 0 === task.status;}
            return true;
            })
            .filter(task => {
            if(this.hold) { return 1 === task.status;}
            return true;
            })
            .filter(task => {
            if(this.done) { return 2 === task.status;} else {
              return !(2 === task.status);
            } 
            //return true;
            });
      }
    },
    methods:{
      ...mapActions(['edittask']),
      holdtask(task) {
          task.status = 1;
          this.edittask(task).then(() => {
            let msg = `Task "${task.task}" <pre>\n</pre> 💼 "${task.project.title}" <pre>\n</pre> is on hold.`;
            sendMessage(msg);

          });
      },
      unholdtask(task) {
          task.status = 0;
          this.edittask(task).then(() => {
            let msg = `Task "${task.task}" <pre>\n</pre> 💼 "${task.project.title}" <pre>\n</pre> is Un-hold successfully.`;
            sendMessage(msg);
          });
      },
      donetask(task) {
          task.status = 2;
          this.edittask(task).then(() => {
            let msg = `✅ ${task.task} <pre>\n</pre> 💼 ${task.project.title}`;
            sendMessage(msg);
          });
      },
    },
    filters: {
        showstatus: function (value) {
            if (!value) return '';
            if(value == 0)
            {
                return 'pending';
            }
            else if(value == 1)
            {
                return 'hold';
            }else if(value == 2) {
                return 'done';
            }

        }
    }
  }
</script>